import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CareCardConfig, PcpData } from '@zipari/shared-ds-util-care-card';
import { PCP } from '@zipari/shared-api-models';
import { copyText } from './care-card.constants';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'care-card',
  templateUrl: './care-card.component.html',
  styleUrls: ['./care-card.component.scss'],
})
export class CareCardComponent implements OnInit {
  @Input() config: CareCardConfig;
  @Input() data: PcpData;
  @Input() change: boolean;
  @Input() columns: boolean;
  @Output() changePCPClicked = new EventEmitter();
  @Output() addPCPClicked: EventEmitter<null> = new EventEmitter();

  public listOfPCPs = [];
  public listOfPCDs = [];
  public copy = copyText;

  ngOnInit() {
    const [config, data] = checkInputsForText([this.config, this.data]);

    this.config = config as CareCardConfig;
    this.data = data as PcpData;

    if (this.data.pcps) {
      this.listOfPCPs = this.data.pcps.filter((pcp) =>
        new RegExp('pcp', 'i').test(pcp.type),
      );
      this.listOfPCDs = this.data.pcps.filter(
        (pcp) =>
          new RegExp('dentist', 'i').test(pcp.type) && this.config.show_dental,
      );
    }
  }

  linkClicked() {
    this.changePCPClicked.emit();
  }

  public pcpAddress(pcp: PCP) {
    const { street_name_1, street_name_2 } = pcp.pcp_address || {};

    return `${street_name_1 || ''} ${street_name_2 || ''}`;
  }
}
